export const getBounds = (maps, traps) => {
  const bounds = new maps.LatLngBounds()

  traps.forEach((trap) => {
    bounds.extend(new maps.LatLng(
      trap.latitude,
      trap.longitude,
    ))
  })

  return bounds
}

export const getMapViewport = ({
  minLongitude, minLatitude, maxLongitude, maxLatitude 
}) => {
  // toFixed() returns a string, which isn't handled by Google API. 
  return {
    lat: parseFloat((((maxLatitude + minLatitude)) / 2).toFixed(7)),
    lng: parseFloat((((maxLongitude + minLongitude)) / 2).toFixed(7))
  }
}

export default {
  getBounds
}



// WEBPACK FOOTER //
// ./src/utils/map.js